import { Link } from 'react-router';
import { PageHead, useAgency } from '../agency';

/** Agency settings landing page. Existing URLs remain valid for bookmarks. */
export function Settings() {
  const a = useAgency();
  return (
    <>
      <PageHead title="Settings" sub="Manage your agency's staff, resources and tools." />
      <div className="cards">
        <Link className="stat" to={`${a.base}/team`}>
          <strong>Staff Directory</strong>
          <p className="sub">View your team{a.manager ? ', invitations, permissions and staff accounts' : ''}.</p>
        </Link>
        <Link className="stat" to={`${a.base}/resources`}>
          <strong>Agency Resources & Quick Links</strong>
          <p className="sub">Open agency links{a.manager ? ' and manage dashboard shortcuts' : ''}.</p>
        </Link>
        {a.manager && (
          <>
            <Link className="stat" to={`${a.base}/archive`}><strong>Archive</strong><p className="sub">Restore archived quotes and requests.</p></Link>
            <Link className="stat" to={`${a.base}/audit`}><strong>Audit Log</strong><p className="sub">Review agency activity and changes.</p></Link>
          </>
        )}
      </div>
    </>
  );
}
